var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tabs"},_vm._l((_vm.scales),function(s,i){return _c('li',{key:s.key,class:{ active: (s.key == _vm.scale.key) },on:{"click":function($event){return _vm.setScale(s, i)}}},[_vm._v("\n\t\t"+_vm._s(s.name)+"\n\t")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }